import styled from 'styled-components';

export const FieldsRow = styled.div`
  display: flex;
  width: 100%;
`;
export const Field = styled.div`
  /* :nth-child(1) {
    padding-inline-end: ${({ theme }) => theme.spacing.x2};
  }
  :nth-child(2) {
    padding-inline-start: ${({ theme }) => theme.spacing.x2};
  } */
  display: flex;
  flex: 1;
`;
